import {AppEventName} from "./AppEventName";

export class AppEvent {

  eventName: AppEventName;
  eventData: any;

  constructor(eventName: AppEventName, eventData: any) {
    this.eventName = eventName;
    this.eventData = eventData;
  }
}
